<template>
  <div id="home-card" class="full-card h-100">
    <div class="w-100 h-100 d-flex flex-start-center">
      <div id="outer_card">
<!--        <svg>-->
<!--          <clipPath id="clip">-->
<!--            <rect id="rect" x="10" y="10" width="50" height="50" />-->
<!--          </clipPath>-->
<!--          <g id="backdrop">-->
<!--            <filter id="blur">-->
<!--              &lt;!&ndash; insert a neutral background color to prevent the backdrop showing-->
<!--                   through blurred regions with alpa < 1 &ndash;&gt;-->
<!--              <feFlood flood-color="#fff" result="neutral"/>-->
<!--              <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blurred" />-->
<!--              <feMerge>-->
<!--                <feMergeNode in="neutral" />-->
<!--                <feMergeNode in="blurred" />-->
<!--              </feMerge>-->
<!--            </filter>-->
<!--            <rect fill="green" x="0" y="0" width="200" height="100" />-->
<!--            &lt;!&ndash;            <use xlink:href="#backdrop" style="filter: url(#blur)" />&ndash;&gt;-->
<!--            &lt;!&ndash;            <rect fill="yellow" x="120" y="40" width="40" height="40" />&ndash;&gt;-->
<!--          </g>-->
<!--          &lt;!&ndash; make sure the clip-path is applied after the filter &ndash;&gt;-->
<!--          <g style="clip-path: url(#clip)">-->
<!--            <use xlink:href="#backdrop" style="filter: url(#blur)" />-->
<!--          </g>-->
<!--          &lt;!&ndash;          <use xlink:href="#rect" style="fill:none;stroke:black" />&ndash;&gt;-->
<!--        </svg>-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="200">-->
<!--          <clipPath id="clip">-->
<!--            <rect id="rect" width="400" height="200" />-->
<!--          </clipPath>-->
<!--          <filter id="blur">-->
<!--            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blurred" />-->
<!--          </filter>-->
<!--          <image id="backdrop" width="400" height="200" href="https://source.unsplash.com/user/c_v_r/1900x800" />-->
<!--          <g>-->
<!--            <use id="overlay" xlink:href="#backdrop" style="filter: url(#blur);" />-->
<!--          </g>-->
<!--          <use xlink:href="#rect" style="fill:none;stroke:black" />-->
<!--        </svg>-->
        <img class="outer_image blur-me" :src="image">
<!--        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="0">-->
<!--          <filter id="myblurfilter" width="110%" height="100%">-->
<!--            <feGaussianBlur stdDeviation="2" result="blur" />-->
<!--          </filter>-->
<!--        </svg>-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="714" height="441.178" viewBox="0 0 714 441.178">-->
<!--          <g transform="translate(0 0)">-->
<!--            <path id="Path_8109" data-name="Path 8109" d="M2205.766,519.128V796.618c0,20.851-16.662,37.755-37.216,37.755H1776.932c-16.069,0-30.073,10.549-35.349,25.948-10.582,30.884-44.291,62.23-86.5,62.23s-70.066-31.346-80.648-62.23c-5.276-15.4-19.279-25.948-35.349-25.948h-.1c-4.234,0-27.879-.717-31.251-2.148-11.764-4.983-15.964-19.05-15.964-35.606V519.128c0-20.852,16.662-37.755,37.216-37.755h639.569C2189.1,481.373,2205.766,498.275,2205.766,519.128Z" transform="translate(-1491.766 -481.373)" fill="#f2f2f2"/>-->
<!--            <path id="Path_8109_-_Outline" data-name="Path 8109 - Outline" d="M1528.982,485.373a32.549,32.549,0,0,0-12.909,2.643,33.086,33.086,0,0,0-10.558,7.223,33.913,33.913,0,0,0-9.749,23.889V796.618c0,8.338,1.1,15.282,3.277,20.638a23.635,23.635,0,0,0,4.2,6.956,17,17,0,0,0,6,4.312c.305.1,2.687.737,14.359,1.335,6.989.358,13.561.513,15.371.513h.1a40.18,40.18,0,0,1,12.836,2.1,40.808,40.808,0,0,1,11.264,5.886,42.244,42.244,0,0,1,8.989,9.053,43.6,43.6,0,0,1,6.044,11.615,98.156,98.156,0,0,0,10.694,21.861,90.617,90.617,0,0,0,16.6,19.1,76.92,76.92,0,0,0,22.114,13.459,74.786,74.786,0,0,0,27.458,5.1,81.86,81.86,0,0,0,28.448-5.133,90.458,90.458,0,0,0,24.2-13.557,95.725,95.725,0,0,0,18.57-19.144,88.7,88.7,0,0,0,6.717-10.726,76.831,76.831,0,0,0,4.776-10.967,43.6,43.6,0,0,1,6.044-11.615,42.244,42.244,0,0,1,8.989-9.053,40.811,40.811,0,0,1,11.264-5.886,40.178,40.178,0,0,1,12.836-2.1h391.619a32.549,32.549,0,0,0,12.909-2.643,33.082,33.082,0,0,0,10.558-7.223,33.913,33.913,0,0,0,9.749-23.888V519.128a33.913,33.913,0,0,0-9.749-23.889,33.085,33.085,0,0,0-10.558-7.223,32.55,32.55,0,0,0-12.909-2.643H1528.982m0-4h639.569c20.553,0,37.216,16.9,37.216,37.755V796.618c0,20.851-16.662,37.755-37.216,37.755H1776.932c-16.069,0-30.073,10.549-35.349,25.948-10.582,30.884-44.291,62.23-86.5,62.23s-70.066-31.346-80.648-62.23c-5.276-15.4-19.279-25.948-35.349-25.948h-.1c-4.234,0-27.879-.717-31.251-2.148-11.764-4.983-15.964-19.05-15.964-35.606V519.128C1491.766,498.275,1508.428,481.373,1528.982,481.373Z" transform="translate(-1491.766 -481.373)" fill="rgba(255,255,255,0.2)"/>-->
<!--          </g>-->
<!--        </svg>-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev/svgjs" viewBox="0 0 800 450"><defs><filter id="bbblurry-filter" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse" color-interpolation-filters="sRGB">-->
<!--          <feGaussianBlur stdDeviation="40" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur></filter></defs><g filter="url(#bbblurry-filter)"><ellipse rx="150" ry="150" cx="500.06966889650295" cy="268.7009590957081" fill="hsl(37, 99%, 67%)"></ellipse><ellipse rx="150" ry="150" cx="157.72957278014732" cy="167.16095309706967" fill="hsl(316, 73%, 52%)"></ellipse><ellipse rx="150" ry="150" cx="594.1006887874285" cy="286.9494700000828" fill="hsl(185, 100%, 57%)"></ellipse></g>-->
<!--        </svg>-->
        <div id="inner_card">
          <div class="card-container">
            <div class="card-title" :class="this.$lang === 'ar' ? 'text-right' : 'text-left'">
              {{item.title}}
            </div>
            <div class="card-description">
              {{item.description}}
            </div>
          </div>
        </div>
        <a :href="item.link" target="_blank">
        <div class="black-blur"></div>
        <div class="yellow-button flex-center">
          <div class="white-blur"></div>
          <img class="inner_arrow" src="../../assets/icons/buttonArrow.svg">
          <span class="read-more">
            {{$t('readMore')}}
<!--            اقرأ المزيد-->
          </span>
        </div>
        <div class="blur-outer-button"></div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import rtlCard from '../../assets/icons/gradient-arabic.svg'
import ltrCard from '../../assets/icons/gradient-card.svg'
import ltrMobile from '../../assets/icons/en.svg'
import rtlMobile from '../../assets/icons/ar.svg'
// import rtlCard from '../../assets/icons/gradient-card.svg'
import $ from 'jquery'
export default {
  name: 'HomeCard',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      item: {},
      image: ''
    }
  },
  created () {
    this.item = this.data
  },
  mounted () {
    this.$lang === 'ar' ? this.image = rtlCard : this.image = ltrCard
    setTimeout(() => {
      this.$lang === 'ar' ? $('.read-more').css('font-family', 'Mtn-arabic-regular') : $('.read-more').css('font-family', 'Mtn-regular')
      this.$lang === 'ar' ? $('.card-title').css('font-family', 'Mtn-arabic-bold') : $('.card-title').css('font-family', 'Mtn-bold-italic')
      this.$lang === 'ar' ? $('.card-description').css('font-family', 'Mtn-arabic-regular') : $('.card-description').css('font-family', 'Mtn-regular')
      // this.$lang === 'ar' ? $('.read-more').css('animation-name', 'rightToLeft') : $('.read-more').css('animation-name', 'leftToRight')
      this.$lang === 'ar' ? $('#home-card .card-description').css('text-align', 'right') : $('#home-card .card-description').css('text-align', 'left')
      // this.$lang === 'ar' ? $('.yellow-button').css('right', '120.5px') : $('.yellow-button').css('left', '120.5px')
      this.style()
    })
    window.addEventListener('resize', () => {
      this.style()
    })
    this.arabic()
  },
  methods: {
    style () {
      if (window.innerWidth < 424) {
        this.image = this.$lang === 'ar' ? rtlMobile : ltrMobile
        this.$lang === 'ar' ? $('#home-card .yellow-button.flex-center').css('right', '52px') && $('#home-card .blur-outer-button').css('right', '58px') && $('#home-card .black-blur').css('left', '300px') && $('img.inner_arrow').css('transform', 'rotate(180deg)') : $('#home-card .yellow-button.flex-center').css('right', '263px') && $('#home-card .blur-outer-button').css('right', '261.5px') && $('#home-card .black-blur').css('left', '95px') && $('img.inner_arrow').css('transform', 'rotate(0deg)')
      } else {
        // this.image = rtlMobile
        this.image = this.$lang === 'ar' ? rtlCard : ltrCard
        this.$lang === 'ar' ? $('#home-card .yellow-button.flex-center').css('right', '129.5px') && $('#home-card .blur-outer-button').css('right', '129px') && $('#home-card .black-blur').css('right', '160px') && $('img.inner_arrow').css('transform', 'rotate(180deg)') : $('#home-card .yellow-button.flex-center').css('left', '121.5px') && $('#home-card .blur-outer-button').css('left', '120px') && $('#home-card .black-blur').css('left', '156px') && $('img.inner_arrow').css('transform', 'rotate(0deg)')
      }
      if (window.innerWidth < 500) {
        this.image = this.$lang === 'ar' ? rtlMobile : ltrMobile
        this.$lang === 'ar' ? $('#home-card .yellow-button.flex-center').css('right', '72.5px') && $('#home-card .blur-outer-button').css('right', '71.5px') && $('#home-card .black-blur').css('right', '93px') && $('img.inner_arrow').css('transform', 'rotate(180deg)') : $('#home-card .yellow-button.flex-center').css('left', '71.5px') && $('#home-card .blur-outer-button').css('left', '70.5px') && $('#home-card .black-blur').css('left', '93px') && $('img.inner_arrow').css('transform', 'rotate(0deg)')
      } else {
        this.image = this.$lang === 'ar' ? rtlCard : ltrCard
      }
      if (window.innerWidth < 390) {
        this.image = this.$lang === 'ar' ? rtlMobile : ltrMobile
        this.$lang === 'ar' ? $('#home-card .yellow-button.flex-center').css('right', '64.5px') && $('#home-card .blur-outer-button').css('right', '63.5px') && $('#home-card .black-blur').css('right', '73px') && $('img.inner_arrow').css('transform', 'rotate(180deg)') : $('#home-card .yellow-button.flex-center').css('left', '62.5px') && $('#home-card .blur-outer-button').css('left', '61.5px') && $('#home-card .black-blur').css('left', '73px') && $('img.inner_arrow').css('transform', 'rotate(0deg)')
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('#random_cards .inner').css('direction', 'rtl')
        $('.small-container').css('direction', 'ltr')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/modules/homeCard";
#outer_card {
  margin: 0 calc(4vw - 56.5px) !important;
  width: 564px!important;
  height: 341px!important;
}
#outer_card .outer_image {
  width: 564px!important;
  height: 341px!important;
}
#inner_card {
  //width: 451.82px !important;
  //height: 190.05px !important;
  ////background: yellow;
  //position: absolute !important;
  //top: 53px !important;
  //left: 52.5px !important;
  width: 451.82px !important;
  height: 142.05px !important;
  position: absolute !important;
  top: 54px !important;
  margin: auto;
  left: 52.5px !important;
}
svg g path {
  //background: rgba(0, 0, 0, 0.5);
  //backdrop-filter: blur(40px)!important;
}
.clip-path {
  //clip-path: polygon(2.2% 42.2%, 5% 50.69%, 5.7% 53.43%, 6.5% 55.52%, 7.0% 57.27%, 7.5% 58.79%, 8.0% 60.16%, 8.5% 61.4%, 9.0% 62.55%, 9.5% 63.62%, 10.0% 64.62%, 10.5% 65.56%, 11.0% 66.45%, 11.5% 67.3%, 12.0% 68.1%, 12.5% 68.87%, 13.0% 69.61%, 13.5% 70.32%, 14.0% 71.0%, 14.5% 71.65%, 15.0% 72.28%, 15.5% 72.89%, 16.0% 73.48%, 16.5% 74.05%, 17.0% 74.59%, 17.5% 75.12%, 18.0% 75.64%, 18.5% 76.14%, 19.0% 76.62%, 19.5% 77.09%, 20.0% 77.54%, 20.5% 77.98%, 21.0% 78.41%, 21.5% 78.82%, 22.0% 79.23%, 22.5% 79.62%, 23.0% 80.0%, 23.5% 80.37%, 24.0% 80.73%, 24.5% 81.08%, 25.0% 81.42%, 25.5% 81.75%, 26.0% 82.07%, 26.5% 82.38%, 27.0% 82.68%, 27.5% 82.97%, 28.0% 83.26%, 28.5% 83.53%, 29.0% 83.8%, 29.5% 84.06%, 30.0% 84.31%, 30.5% 84.56%, 31.0% 84.79%, 31.5% 85.02%, 32.0% 85.24%, 32.5% 85.46%, 33.0% 85.67%, 33.5% 85.87%, 34.0% 86.06%, 34.5% 86.25%, 35.0% 86.43%, 35.5% 86.6%, 36.0% 86.77%, 36.5% 86.93%, 37.0% 87.08%, 37.5% 87.23%, 38.0% 87.37%, 38.5% 87.51%, 39.0% 87.63%, 39.5% 87.76%, 40.0% 87.87%, 40.5% 87.99%, 41.0% 88.09%, 41.5% 88.19%, 42.0% 88.28%, 42.5% 88.37%, 43.0% 88.45%, 43.5% 88.53%, 44.0% 88.6%, 44.5% 88.66%, 45.0% 88.72%, 45.5% 88.77%, 46.0% 88.82%, 46.5% 88.86%, 47.0% 88.9%, 47.5% 88.93%, 48.0% 88.96%, 48.5% 88.97%, 49.0% 88.99%, 49.5% 89.0%, 50.0% 89.0%, 50.5% 89.0%, 51.0% 88.99%, 51.5% 88.97%, 52.0% 88.96%, 52.5% 88.93%, 53.0% 88.9%, 53.5% 88.86%, 54.0% 88.82%, 54.5% 88.77%, 55.0% 88.72%, 55.5% 88.66%, 56.0% 88.6%, 56.5% 88.53%, 57.0% 88.45%, 57.5% 88.37%, 58.0% 88.28%, 58.5% 88.19%, 59.0% 88.09%, 59.5% 87.99%, 60.0% 87.87%, 60.5% 87.76%, 61.0% 87.63%, 61.5% 87.51%, 62.0% 87.37%, 62.5% 87.23%, 63.0% 87.08%, 63.5% 86.93%, 64.0% 86.77%, 64.5% 86.6%, 65.0% 86.43%, 65.5% 86.25%, 66.0% 86.06%, 66.5% 85.87%, 67.0% 85.67%, 67.5% 85.46%, 68.0% 85.24%, 68.5% 85.02%, 69.0% 84.79%, 69.5% 84.56%, 70.0% 84.31%, 70.5% 84.06%, 71.0% 83.8%, 71.5% 83.53%, 72.0% 83.26%, 72.5% 82.97%, 73.0% 82.68%, 73.5% 82.38%, 74.0% 82.07%, 74.5% 81.75%, 75.0% 81.42%, 75.5% 81.08%, 76.0% 80.73%, 76.5% 80.37%, 77.0% 80.0%, 77.5% 79.62%, 78.0% 79.23%, 78.5% 78.82%, 79.0% 78.41%, 79.5% 77.98%, 80.0% 77.54%, 80.5% 77.09%, 81.0% 76.62%, 81.5% 76.14%, 82.0% 75.64%, 82.5% 75.12%, 83.0% 74.59%, 83.5% 74.05%, 84.0% 73.48%, 84.5% 72.89%, 85.0% 72.28%, 85.5% 71.65%, 86.0% 71.0%, 86.5% 70.32%, 87.0% 69.61%, 87.5% 68.87%, 88.0% 68.1%, 88.5% 67.3%, 89.0% 66.45%, 89.5% 65.56%, 90.0% 64.62%, 90.5% 63.62%, 91.0% 62.55%, 91.5% 61.4%, 92.0% 60.16%, 92.5% 58.79%, 93.0% 57.27%, 93.5% 55.52%, 94.2% 53.43%, 94.9% 50.69%, 98.0% 42.2%);
  //clip-path: d="M2205.766,519.128V796.618c0,20.851-16.662,37.755-37.216,37.755H1776.932c-16.069,0-30.073,10.549-35.349,25.948-10.582,30.884-44.291,62.23-86.5,62.23s-70.066-31.346-80.648-62.23c-5.276-15.4-19.279-25.948-35.349-25.948h-.1c-4.234,0-27.879-.717-31.251-2.148-11.764-4.983-15.964-19.05-15.964-35.606V519.128c0-20.852,16.662-37.755,37.216-37.755h639.569C2189.1,481.373,2205.766,498.275,2205.766,519.128Z";
}
.blur-me {
  //-webkikt-filter: url('#myblur');
  //filter: url('#myblur');
}
.blurme {
  -webkikt-filter: url('#myblurfilter');
  filter: url('#myblurfilter'); }
.card-title {
  //font-family: Mtn-bold-italic!important;
  font-style: italic;
}
.card-description {
  -webkit-line-clamp: 4!important;
}
.yellow-button {
  bottom: 38px !important;
  //left: 120.5px!important;
}
.black-blur {
  bottom: 42px!important;
}
.blur-outer-button {
  bottom: 36.5px!important;
}
#inner_card .card-container {
  margin: 0 2.5rem!important
}
@media screen and (max-width: 500px) {
  #outer_card {
    margin: 0 4vw !important;
    width: 350.66px !important;
    height: 333.26px !important;
  }
  #outer_card .outer_image {
    width: 350.66px !important;
    height: 333.26px !important;
  }
  .yellow-button {
    width: 72px !important; height: 72px!important;
  }
  .blur-outer-button {
    width: 74px!important; height: 74px!important;
    bottom: 37.5px!important;
  }
  #inner_card {
    width: 349.82px !important;
    height: 142.05px !important;
    top: 63px !important;
    margin: auto;
    //background: red;
    left: 0.5px !important;
  }
}
@media screen and (max-width: 390px) {
  #outer_card {
    margin: 0 4vw !important;
    width: 297.66px !important;
    height: 338.26px !important;
  }
  #outer_card .outer_image {
    width: 297.66px !important;
    height: 338.26px !important;
  }
  .yellow-button {
    width: 57px !important; height: 57px!important;
    bottom: 62px!important;
  }
  .blur-outer-button {
    width: 59px!important; height: 59px!important;
    bottom: 60.5px!important;
  }
  #inner_card {
    width: 297.66px !important;
    height: 142.05px !important;
    top: 58px !important;
    margin: auto;
    //background: red;
    left: 0.5px !important;
  }
  #inner_card .card-container {
    margin: 0 1rem !important;
  }
  .black-blur {
    bottom: 60px!important;
  }
  .read-more {
    font-size: 8.5px!important;
    right: calc(50% - 22.5px)!important;
    width: 45px;
  }
}

</style>
